const ACTION = {
  SET_STATE: "SET_STATE",

  SET_LISTENER: "SET_LISTENER",
  
  UNSUBSCRIBE_LISTENER: "UNSUBSCRIBE_LISTENER",

  CREATE_EXPENSES_REQUEST: "CREATE_EXPENSES_REQUEST",
  CREATE_EXPENSES_SUCCESS: "CREATE_EXPENSES_SUCCESS",
  CREATE_EXPENSES_FAILURE: "CREATE_EXPENSES_FAILURE",

  UPDATE_EXPENSES_REQUEST: "UPDATE_EXPENSES_REQUEST",
  UPDATE_EXPENSES_SUCCESS: "UPDATE_EXPENSES_SUCCESS",
  UPDATE_EXPENSES_FAILURE: "UPDATE_EXPENSES_FAILURE",

  APPROVE_EXPENSES_REQUEST: "APPROVE_EXPENSES_REQUEST",
  APPROVE_EXPENSES_SUCCESS: "APPROVE_EXPENSES_SUCCESS",
  APPROVE_EXPENSES_FAILURE: "APPROVE_EXPENSES_FAILURE",

  REJECT_EXPENSES_REQUEST: "REJECT_EXPENSES_REQUEST",
  REJECT_EXPENSES_SUCCESS: "REJECT_EXPENSES_SUCCESS",
  REJECT_EXPENSES_FAILURE: "REJECT_EXPENSES_FAILURE",

  LOAD_SUBMITTED_EXPENSES_REQUEST: "LOAD_SUBMITTED_EXPENSES_REQUEST",
  LOAD_SUBMITTED_EXPENSES_SUCCESS: "LOAD_SUBMITTED_EXPENSES_SUCCESS",
  LOAD_SUBMITTED_EXPENSES_FAILURE: "LOAD_SUBMITTED_EXPENSES_FAILURE",

  LOAD_APPROVED_EXPENSES_REQUEST: "LOAD_APPROVED_EXPENSES_REQUEST",
  LOAD_APPROVED_EXPENSES_SUCCESS: "LOAD_APPROVED_EXPENSES_SUCCESS",
  LOAD_APPROVED_EXPENSES_FAILURE: "LOAD_APPROVED_EXPENSES_FAILURE",

  LOAD_REJECTED_EXPENSES_REQUEST: "LOAD_REJECTED_EXPENSES_REQUEST",
  LOAD_REJECTED_EXPENSES_SUCCESS: "LOAD_REJECTED_EXPENSES_SUCCESS",
  LOAD_REJECTED_EXPENSES_FAILURE: "LOAD_REJECTED_EXPENSES_FAILURE",

  LOAD_MY_EXPENSES_REQUEST: "LOAD_MY_EXPENSES_REQUEST",
  LOAD_MY_EXPENSES_SUCCESS: "LOAD_MY_EXPENSES_SUCCESS",
  LOAD_MY_EXPENSES_FAILURE: "LOAD_MY_EXPENSES_FAILURE",
}

export default ACTION
